import { render, staticRenderFns } from "./unassignedlist.vue?vue&type=template&id=546d7c5e&"
import script from "./unassignedlist.vue?vue&type=script&lang=js&"
export * from "./unassignedlist.vue?vue&type=script&lang=js&"
import style0 from "./unassignedlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports